import type Lenis from "lenis";

// Module-level singleton reference — set by SmoothScrollProvider after init
let _lenis: Lenis | null = null;

export function setLenisInstance(instance: Lenis) {
  _lenis = instance;
}

export function scrollToElement(targetId: string, offset: number = 100): void {
  if (typeof window === "undefined") return;

  const targetElement = document.getElementById(targetId);
  if (!targetElement) return;

  if (_lenis) {
    _lenis.scrollTo(targetElement, { offset, lerp: 0.04 });
    return;
  }

  // Fallback if Lenis hasn't initialized yet
  const elementTop = targetElement.getBoundingClientRect().top + window.scrollY;
  const finalPosition = Math.min(
    elementTop + offset,
    document.documentElement.scrollHeight - window.innerHeight,
  );
  window.scrollTo({ top: finalPosition, behavior: "smooth" });
}

export function useScrollToContact() {
  return () => scrollToElement("contact-main", -100);
}

export function useScrollToCareerForm() {
  return () => scrollToElement("career-form", -100);
}
